<template>
  <Loading :loading="!loading_is_complete"></Loading>

  <div v-if="loading_is_complete" class="container container_product-name">
    <div class="page__block">
      <h1 class="page__title h1">{{ product.name }}</h1>
    </div>
  </div>

  <!--  ««« Фотогалерея и основная информация-->
  <div v-if="loading_is_complete" class="page__section">
    <div class="container">
      <div class="product-block product-block_primary">
        <!-- ««« Колонка с фотографиями-->
        <div class="product-block__first-column">
          <ProductGallery />
        </div>
        <!-- Колонка с фотографиями »»»-->

        <!-- ««« Колонка с ценой-->
        <div class="product-block__second-column">
          <div v-if="show_prices" class="product-block__container">
            <ProductPrice
              :price="{ name: product.price_name, value: product.price_value }"
              :old_price="{
                name: product.old_price_name,
                value: product.old_price_value,
              }"
            />
          </div>

          <div class="product-block__container">
            <ProductShortSpecification />
          </div>

          <ProductOrderBlock />
        </div>
        <!-- Колонка с ценой »»»-->
      </div>
    </div>
  </div>
  <!-- Фотогалерея и основная информация »»»-->
  <ProductAdvantages />
  <!--  ««« Описание и форма обратной связи-->
  <div v-if="loading_is_complete" class="page__section product-description">
    <div class="container">
      <div class="page__block">
        <div class="product-block product-block_secondary">
          <!-- ««« Колонка с табами описания-->
          <ProductDescription />
          <!-- Колонка с табами описания »»»-->

          <!-- -->
          <div
            style="
              font-size: 10px;
              font-style: italic;
              color: #a8a0a0;
              padding-top: 40px;
            "
          >
            Вся информация на сайте о товарах и ценах носит справочный характер
            и не является публичной офертой в соответствии с пунктом 2 статьи
            437 ГК РФ. Производитель оставляет за собой право изменять
            характеристики товара, его внешний вид, комплектность и цену без
            предварительного уведомления продавца
          </div>
          <!-- -->
          <!-- ««« Колонка с формой обратной связи -->
          <ProductFeedBack />
          <!-- Колонка с формой обратной связи »»»-->
        </div>
      </div>
    </div>
  </div>

  <div v-if="product.analogs && product.analogs.length" class="page__section">
    <div class="container container_for-similar">
      <ProductAnalogs />
    </div>
  </div>

  <div class="page__section"></div>
</template>

<script>
import Loading from "../components/Loading";

import ProductGallery from "../components/ForProductCard/ProductGallery";
import ProductShortSpecification from "../components/ForProductCard/ProductShortSpecification";
import ProductPrice from "../components/ForProductCard/ProductPrice";
import ProductOrderBlock from "../components/ForProductCard/ProductOrderBlock";
import ProductDescription from "../components/ForProductCard/ProductDescription";
import ProductFeedBack from "../components/ForProductCard/ProductFeedBack";
import ProductAdvantages from "../components/ForProductCard/ProductAdvantages";
import ProductAnalogs from "../components/ForProductCard/ProductAnalogs";

export default {
  name: "ProductCard",
  components: {
    Loading,
    ProductGallery,
    ProductDescription,
    ProductFeedBack,
    ProductShortSpecification,
    ProductOrderBlock,
    ProductPrice,
    ProductAdvantages,
    ProductAnalogs,
  },
  updated() {
    // if (this.product) {
    //   document.title = this.product.name
    //   if (document.querySelector('meta[name="description"]') !== null)
    //     document.querySelector('meta[name="description"]').setAttribute('content', this.product.meta_description)
    //   if (document.querySelector('meta[name="title"]') == null) {
    //     let m = document.createElement('meta')
    //     m.name = 'title'
    //     document.head.appendChild(m)
    //   }
    //   if (document.querySelector('meta[name="title"]') !== null) {
    //     document.querySelector('meta[name="title"]').setAttribute('content', this.product.meta_title)
    //   }
    // }
  },
  beforeMount() {
    this.$store.dispatch(
      "product/FETCH_PRODUCT",
      this.$route.params.product_slug
    );
  },
  data() {
    return {
      show_prices: true,
    };
  },
  computed: {
    loading_is_complete() {
      return this.$store.getters["product/GET_LOADING_IS_COMPLETE"];
    },
    product() {
      return this.$store.getters["product/GET_PRODUCT"];
    },
  },
  methods: {},
};
</script>

<style scoped></style>
